import { render, staticRenderFns } from "./Fault.vue?vue&type=template&id=0f5f1441&scoped=true&"
import script from "./Fault.vue?vue&type=script&lang=js&"
export * from "./Fault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5f1441",
  null
  
)

export default component.exports